import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { DataResponse, ZendeskTicketAuditsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof ZendeskTicketAuditsResponseDataSchema>>

type Props = {
  enabled?: boolean
} & ({ ticketId: string } | { issueId: string })

const getZendeskAuditsQueryKey = (props: Props) =>
  "issueId" in props
    ? ["support", "issues", props.issueId, "zendesk", "audits"]
    : ["support", "tickets", props.ticketId, "zendesk", "audits"]

export const zendeskTicketAuditsQuery = (props: Props) => {
  const { enabled } = props

  return queryOptions({
    queryKey: getZendeskAuditsQueryKey(props),
    queryFn: async () => {
      const path =
        "issueId" in props
          ? `/support/issues/${props.issueId}/zendesk/audits`
          : `/support/tickets/${props.ticketId}/zendesk/audits`
      const response = await axios.get<Response>(path)

      return response.data.data
    },
    enabled,
    staleTime: 5 * MINUTES_TO_MILLIS,
  })
}
